module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado7.944a2153.svg";